<template>
  <v-row align="start" justify="end" class="mb-6 mb-md-16">
    <v-col cols="12" md="10">
      <generic-list-item :content="content" :index="index" :momentum="momentum" />
    </v-col>
  </v-row>
</template>

<script>
import GenericListItem from './GenericListItem.vue'
export default {
  name: 'GenericListItemOffsetted',
  components: { GenericListItem },
  props: {
    content: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    momentum: {
      type: Number,
      required: false
    }
  }
}
</script>
